export default __webpack_public_path__ + "static/media/google-drive-logo.060ed905.svg";